import { Box, Button, CircularProgress, Modal, Stack } from "@mui/material";

import React, { type FC } from "react";

type ConfirmationPopupProps = {
  isLoading?: boolean;
  isOpen: boolean;
  onOk: () => void;
  onCancel: () => void;
  okButtonProps?: React.ComponentProps<typeof Button>;
  okButtonText?: string;
  cancelButtonText?: string;
  body: React.ReactNode;
  footer?: React.ReactNode; // Use footer to set custom footer
  style?: Object;
};

const defaultStyle = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
  borderRadius: "10px",
};

export const ConfirmationPopup: FC<ConfirmationPopupProps> = ({
  isLoading,
  isOpen,
  onOk,
  onCancel,
  okButtonProps,
  okButtonText = "Yes",
  cancelButtonText = "No",
  body,
  footer,
  style,
}: ConfirmationPopupProps) => {
  return (
    <Modal
      open={isOpen}
      onClose={onCancel}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{ border: "none" }}
    >
      <Box sx={{ ...defaultStyle, ...style }}>
        {body}

        {footer ? (
          footer
        ) : (
          <Stack
            alignItems="center"
            direction="row"
            justifyContent="center"
            sx={{ py: 2 }}
          >
            <Stack alignItems="center" direction="row" spacing={2}>
              <Button
                sx={{ minWidth: "120px" }}
                variant="outlined"
                onClick={onCancel}
              >
                {cancelButtonText}
              </Button>
              <Button
                {...{
                  variant: "contained",
                  sx: { minWidth: "120px" },
                  ...okButtonProps,
                }}
                onClick={onOk}
                disabled={isLoading}
                type="submit"
              >
                {isLoading ? (
                  <CircularProgress style={{ color: "#FFFFFF" }} size={20} />
                ) : (
                  okButtonText
                )}
              </Button>
            </Stack>
          </Stack>
        )}
      </Box>
    </Modal>
  );
};
